/** Opções de abas/seções para exportação Excel e PDF */
export const ABAS_EXPORTACAO = Object.freeze([
  {
    id: 'resumo',
    label: 'Resumo para o ancião',
    descricao: 'Crianças e jovens separados, em linguagem simples',
  },
  {
    id: 'bairros',
    label: 'Por bairro',
    descricao: 'Números por região da cidade',
  },
  {
    id: 'pessoas',
    label: 'Listas (crianças + jovens)',
    descricao: 'Duas listas separadas, com endereço',
  },
  {
    id: 'atencao',
    label: 'Quem precisa de atenção',
    descricao: 'Irregulares e quem não comparece',
  },
  {
    id: 'jovens',
    label: 'Jovens · Batismo',
    descricao: 'Situação de batismo dos jovens',
  },
  {
    id: 'sem_local',
    label: 'Sem localização',
    descricao: 'Membros sem coordenadas GPS',
  },
]);

export const ABAS_EXPORTACAO_IDS = ABAS_EXPORTACAO.map((aba) => aba.id);

export function abasPadraoSelecionadas() {
  return Object.fromEntries(ABAS_EXPORTACAO_IDS.map((id) => [id, true]));
}

export function listaAbasSelecionadas(selecao = {}) {
  return ABAS_EXPORTACAO_IDS.filter((id) => selecao[id]);
}
